import axiosTransform from 'common/axios'
import { DEFAULT_ERROR_MESSAGE } from '../../../common/constants'

export const BASE_URL = '/gb/moments/'

export const BASE_AJAX_URL = '/gb/ajax/moments/'

export const MAX_FILES = 10

export function handleError(error) {
  let errMessages = [DEFAULT_ERROR_MESSAGE]
  if (error.response.status === 403) return
  if (error.response.status === 422) {
    errMessages = error.response.data.errors
  }
  if (error.response.status === 413) {
    errMessages = ['Images size exceeds limits.']
  }

  errMessages.forEach((errorText) => {
    toastr.error(errorText)
  })
}

export const FB_STATUSES = {
  skipped: 'Skipped',
  scheduled: 'Pending',
  published: 'Delivered',
  error: 'Error'
}

export const COLLAGE_RATIO_EPSILON = 0.1
export const COLLAGE_STATES = {
  INITIAL: 'INITIAL',
  BEFORE_SELECTED: 'BEFORE_SELECTED',
  AFTER_SELECTED: 'AFTER_SELECTED',
  FINISHED: 'FINISHED',
  DISABLED: 'DISABLED'
}

export const REVIEW_KINDS = {
  OFF: 'OFF',
  GMB: 'GMB',
  FREE_FORM: 'FREE_FORM'
}

export const ADDRESS_SOURCES = {
  GOOGLE_AUTOCOMPLETE: 'GOOGLE_AUTOCOMPLETE',
  FROM_OFFICE: 'FROM_OFFICE',
  FROM_ST_JOB: 'FROM_ST_JOB',
  PUBLIC_API_ADDRESS: 'PUBLIC_API_ADDRESS'
}

export const fetchCategoriesForSelect = (params = {}) => axios.get(
  '/gb/ajax/categories',
  { params, ...axiosTransform }
).then((response) => response.data)

export const fetchEmployeesForSelect = (params = {}) => axios.get(
  '/gb/ajax/employees',
  { params, ...axiosTransform }
).then((response) => response.data)

export const fetchBusinesses = (params = {}) => axios.get(
  '/gb/ajax/businesses',
  { params, ...axiosTransform }
).then((response) => ({
  businesses: response.data,
  totalPages: parseInt(response.headers['total-pages'], 10)
}))

export const fetchBusiness = (businessId) => axios.get(
  `/gb/ajax/businesses/${businessId}`,
  axiosTransform
).then((response) => response.data)

export const fetchBusinessesForSelect = (params = {}) => axios.get(
  '/gb/ajax/businesses/index_for_select',
  { params, ...axiosTransform }
).then((response) => response.data)
